module.exports = __webpack_public_path__ + "static/fx_8.db931629.jpg";